type ReadingPlanType = {
    whole: 0,
    nt: 1,
    ot: 2,
    multi: 3,
    single: 4,
    topical: 5,
}
export const ReadingPlanTypes: ReadingPlanType = {
    whole: 0,
    nt: 1,
    ot: 2,
    multi: 3,
    single: 4,
    topical: 5,
}

export type ReadingPlanTypesValues = typeof ReadingPlanTypes[keyof typeof ReadingPlanTypes]

export const AllReadingPlanTypes: ReadingPlanTypesValues[] = Array.from(Object.values(ReadingPlanTypes));

export const ReadingPlanTypesNames:{ [key in ReadingPlanTypesValues]: string } = {
    [ReadingPlanTypes.whole]: 'Whole Bible',
    [ReadingPlanTypes.nt]: 'New Testament',
    [ReadingPlanTypes.ot]: 'Old Testament',
    [ReadingPlanTypes.multi]: 'Multiple Books',
    [ReadingPlanTypes.single]: 'Single Book',
    [ReadingPlanTypes.topical]: 'Topical',
}

export default ReadingPlanTypes;